module.exports = __webpack_public_path__ + "assets/images/sorvete_bfe34f7fc4890ef7b54c155b59aeb839.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yellow/cone/sorvete.png
// module id = 195
// module chunks = 0